import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";
import FragmentDataType from "../enums/fragment-data-type";

export default class Downed extends Fragment {
    constructor(downedBy) {
        super();

        this.code = "DN";
        this.downedBy = downedBy;

        this.requiredData = [
            {
                name: "downedBy",
                type: FragmentDataType.Player,
                displayName: "Downed By",
                title: (team) => `Downed By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player
                     from ${team.teamName} or enter the roster number`,
                isEditable: true
            }
        ];
    }

    summarize(summaryContext, stringifier) {
        const message = `downed at ${stringifier.niceFieldPosition(
            summaryContext.gameConfig.general.fieldLength,
            summaryContext.fieldPosition,
            summaryContext.homeTeam?.abbrName,
            summaryContext.awayTeam?.abbrName
        )} by ${stringifier.firstInitial(this.downedBy)}`;

        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
    }

    getPlayers() {
        return [this.downedBy];
    }

    getFragmentTeamId() {
        return this.downedBy?.teamId;
    }
}
